const LOGOS = [
  { src: '/assets/logos/bloomberg.png', alt: 'Bloomberg', height: 'h-6 md:h-8' },
  { src: '/assets/logos/jill-on-money.png', alt: 'Jill on Money', height: 'h-12 md:h-16' },
  { src: '/assets/logos/fortune.png', alt: 'Fortune', height: 'h-6 md:h-8' },
  { src: '/assets/logos/axios.png', alt: 'Axios', height: 'h-6 md:h-8' },
  { src: '/assets/logos/yahoo-finance.png', alt: 'Yahoo Finance', height: 'h-6 md:h-8' },
  { src: '/assets/logos/cnbc.png', alt: 'CNBC', height: 'h-6 md:h-8' },
  { src: '/assets/logos/new-york-times.png', alt: 'The New York Times', height: 'h-6 md:h-8' },
  { src: '/assets/logos/ai-insider.png', alt: 'AI Insider', height: 'h-6 md:h-8' },
  { src: '/assets/logos/alleywatch.png', alt: 'AlleyWatch', height: 'h-6 md:h-8' },
  { src: '/assets/logos/icon-yellow.png', alt: 'Featured in', height: 'h-12 md:h-16' },
  { src: '/assets/logos/npr.png', alt: 'NPR', height: 'h-6 md:h-8' },
  { src: '/assets/logos/new-york-post.png', alt: 'New York Post', height: 'h-6 md:h-8' },
]

function LogoRow({ label }: { label: string }) {
  return (
    <div className="flex shrink-0 items-center gap-8 md:gap-12 pr-8 md:pr-12" aria-label={label}>
      {LOGOS.map((logo) => (
        <img
          key={logo.alt}
          src={logo.src}
          alt={logo.alt}
          className={`${logo.height} w-auto object-contain shrink-0`}
        />
      ))}
    </div>
  )
}

export function LogoMarquee() {
  return (
    <section className="bg-white py-10 md:py-16 overflow-hidden">
      <p className="text-xs font-medium text-[#0a0a0a] tracking-[0.24px] uppercase text-center mb-6 md:mb-8">
        AS COVERED IN
      </p>
      <div
        className="group relative"
        style={{
          maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
          WebkitMaskImage:
            'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
        }}
      >
        <div className="flex w-max animate-[marquee_30s_linear_infinite] group-hover:[animation-play-state:paused]">
          <LogoRow label="Press logos" />
          <LogoRow label="Press logos (repeated)" />
        </div>
      </div>
    </section>
  )
}
